import type { ReactNode } from 'react';

export function Cargando({ texto = 'Cargando…' }: { texto?: string }) {
  return (
    <div className="flex items-center justify-center gap-3 px-6 py-16 text-sm text-debil">
      <span className="h-4 w-4 animate-spin rounded-full border-2 border-white/20 border-t-lima" />
      {texto}
    </div>
  );
}

export function Vacio({ titulo, detalle }: { titulo: string; detalle?: string }) {
  return (
    <div className="px-6 py-20 text-center">
      {/* Sin logo a propósito: la marca vive en la barra superior y en el login. */}
      <div
        className="mx-auto mb-5 h-px w-12 bg-gradient-to-r from-transparent via-white/25 to-transparent"
        aria-hidden
      />
      <div className="text-sm text-debil">{titulo}</div>
      {detalle && <div className="mx-auto mt-2 max-w-md text-xs text-mudo">{detalle}</div>}
    </div>
  );
}

type Tono = 'info' | 'aviso' | 'error' | 'ok';

const TONOS: Record<Tono, string> = {
  info: 'border-cian/25 bg-cian/[.08] text-cuerpo',
  aviso: 'border-ambar/30 bg-ambar/[.08] text-cuerpo',
  error: 'border-coral/30 bg-coral/[.08] text-cuerpo',
  ok: 'border-lima/30 bg-lima/[.08] text-cuerpo',
};

export function Aviso({ tono = 'info', children }: { tono?: Tono; children: ReactNode }) {
  return (
    <div className={`rounded-[10px] border px-3.5 py-3 text-[12.5px] leading-relaxed ${TONOS[tono]}`}>
      {children}
    </div>
  );
}

/// Pantalla de error a página completa, con el motivo bien visible.
export function PantallaMensaje({
  titulo,
  children,
  accion,
}: {
  titulo: string;
  children: ReactNode;
  accion?: ReactNode;
}) {
  return (
    <div className="flex min-h-full items-center justify-center px-5 py-16">
      <div className="w-full max-w-[520px] overflow-hidden rounded-2xl border border-white/10 bg-panel shadow-modal">
        <div className="h-1 bg-gradient-to-r from-verde via-azul to-panel" />
        <div className="px-8 py-9">
          <h1 className="font-titulo text-[22px] font-extrabold text-texto">{titulo}</h1>
          <div className="mt-3 space-y-3 text-sm leading-relaxed text-tenue">{children}</div>
          {accion && <div className="mt-7">{accion}</div>}
        </div>
      </div>
    </div>
  );
}
